RivalIQ.apps.Discovery.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const Influencers = RivalIQ.data.CacheLayer.extend({
        name: 'DiscoveryInfluencers',
        cacheKeys: [
            'channel',
            'handle'
        ],

        loadData: function (attrs) {
            const url = [
                '/api/accounts',
                RivalIQ.state.account.get('id'),
                'discovery',
                attrs.channel,
                'influencers',
                encodeURIComponent(attrs.handle)
            ].join('/');

            return $.get(url);
        }
    });

    data.influencers = new Influencers();
});
